// Third-party library imports go here
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  getFacetsStore() {
    try {
      const facetsStore = JSON.parse(localStorage.getItem('facetsStore'));
      return facetsStore;
    } catch (e) {
      console.log(e);
    }
  }

  setFacetsStore(facetsStore: any) {
    try {
      window.localStorage.setItem('facetsStore', JSON.stringify(facetsStore));
    } catch (e) {
      console.log(e);
    }
  }

  removeFacetsStore() {
    try {
      localStorage.removeItem('facetsStore');
    } catch (e) {
      console.log(e);
    }
  }

  isLocalStorageSupported() {
    var mod = 'localStorageTest';
    try {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  updateLocalStorage(payload_key: any, payload_value: any) {
    try {
      const existingObj = JSON.parse(localStorage.getItem('facetsStore'));
      if (existingObj) {
        existingObj[payload_key] = payload_value;
      }
      window.localStorage.setItem('facetsStore', JSON.stringify(existingObj));
      return existingObj;
    } catch (error) {
      return null;
    }
  }

  getValue(payload_key: any) {
    try {
      const existingObj = JSON.parse(localStorage.getItem('facetsStore'));
      if (existingObj) {
        return existingObj[payload_key];
      }
      return '';
    } catch (error) {
      return '';
    }
  }
}
